import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Side By Side Paragraph And Tags",
    fields: {
        tagsTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Tags Title"
        },
        gap: {
            type: FIELD_TYPES.TEXT,
            label: "Space between paragraph and tags"
        },
        fullParagraph: {
            type: FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: FullParagraphFieldsConfig
        }
    }
};
